<template>
  <div id="auth">
    <div ref="linkTitle">
      <LinkTitle></LinkTitle>
    </div>
    <div class="authBox">
      <div ref="header">
        <PageSearchTitle :hideCart="true" :hideSearch="true" title="商家入驻" />
      </div>
      <div class="authContainer" :style="{ height }">
        <div class="authBoxLeft">
          <div class="steps">
            <div class="stepsTitle">- 认证流程 -</div>
            <div class="stepsBox">
              <el-steps
                :space="90"
                direction="vertical"
                align-center
                :active="active"
                finish-status="success"
              >
                <el-step
                  title="提交个人认证"
                  description="个人类型认证成功后您将可以发布供需信息"
                ></el-step>
                <el-step title="等待工作人员审核"></el-step>
                <el-step title="个人认证成功"></el-step>
                <el-step
                  title="提交企业认证"
                  description="企业类型认证成功后您将拥有自己的店铺"
                ></el-step>
                <el-step title="等待工作人员审核"></el-step>
                <el-step title="完成入驻"></el-step>
              </el-steps>
            </div>
          </div>
        </div>
        <div class="authBoxRight">
          <div class="startBox" v-if="path == '/auth'">
            <div class="startBoxTitle">
              <div class="startBoxTitleInfo">
                {{ state }}
              </div>
              {{ textInfo }}
            </div>
            <el-button
              type="info"
              @click="startAuth"
              class="startBoxBtn"
              icon="el-icon-edit"
              >{{ btnInfo }}</el-button
            >
          </div>
          <div v-else>
            <router-view :height="parseInt(height)"></router-view>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import PageSearchTitle from "@/components/components/PageSearchTitle";
import PersonAuth from "./PersonAuth";
import { newQueryMyAuth } from "@/api/api";

import { mapState } from "vuex";
export default {
  created() {
    this.queryAuth();
  },
  mounted() {
    this.setHeight();
    window.addEventListener("resize", this.setHeight);
    this.getPath();
  },
  computed: {
    ...mapState(["userInfo", "companyInfo"]),
    storeType() {
      if (this.companyInfo) {
        if (this.companyInfo.type == 1) {
          return "(商贸公司)";
        } else if (this.companyInfo.type == 2) {
          return "(肉联厂)";
        } else if (this.companyInfo.type == 3) {
          return "(个人店铺)";
        } else if (this.companyInfo.type == 4) {
          return "(养殖场)";
        } else if (this.companyInfo.type == 5) {
          return "(个体户)";
        } else if (this.companyInfo.type == 6) {
          return "(饲料厂)";
        } else if (this.companyInfo.type == 7) {
          return "(动保厂)";
        } else if (this.companyInfo.type == 8) {
          return "添(加剂厂)";
        } else if (this.companyInfo.type == 8) {
          return "(养殖户)";
        } else {
          return "";
        }
      }
      return "";
    },
  },
  data() {
    return {
      active: "",
      state: "个人认证尚未提交",
      height: "",
      path: "",
      textInfo: "个人类型认证成功后您将可以发布供需信息",
      btnInfo: "申请个人认证",
    };
  },
  components: {
    personAuth: PersonAuth,
  },
  watch: {
    "$route.path": function (newval, oldval) {
      // alert(JSON.stringify(newval))
      if (newval == "/auth") {
        this.queryAuth();
      }
      this.path = newval;
    },
  },

  methods: {
    getPath() {
      this.path = this.$route.path;
    },
    startAuth() {
      this.$checkLogin(this.userInfo)
        .then(() => {
          if (this.active === "") {
            this.$router.push("/auth/personAuth");
            this.active = 0;
          } else if (this.active == "1") {
            this.$alert("个人认证审核中，请耐心等待");
          } else if (this.active == "0") {
            this.$router.push("/auth/personAuth");
            this.active = 0;
          } else if (this.active == "2") {
            this.$router.push("/auth/storeAuth");
            this.active = 3;
          } else if (this.active == "4") {
            this.$alert("企业认证审核中，请耐心等待");
          } else if (this.active == "5") {
            this.$alert("相关功能暂未开放");
          }
        })
        .catch(() => {
          this.$router.push("/login");
        });
    },
    setHeight() {
      let titleHeight = this.$refs.linkTitle.offsetHeight;
      let headerHeight = this.$refs.header.offsetHeight;
      console.log("titleHeight", titleHeight);
      console.log("headerHeight", headerHeight);
      let h = "";
      h = window.innerHeight - headerHeight - titleHeight - 30;
      console.log(this.h);
      if (h < 500) {
        h = 500;
      }
      this.height = h + "px";
    },
    inputBlur() {
      this.testForm(this.authForm, 1);
    },
    setStatusIcon() {},
    //         front_img
    // reverse_img
    // hand_cardimg
    queryAuth() {
      if (this.userInfo && this.userInfo.access_token) {
        let url = newQueryMyAuth;
        let data = {
          access_token: this.userInfo.access_token,
        };
        console.log("data", data);
        let param = new URLSearchParams();
        for (var k in data) {
          param.append(k, data[k]);
        }
        this.$axios({
          method: "post",
          data: param,
          url,
        })
          .then((res) => {
            console.log(res);
            if (res.data.resultCode == 1) {
              let { p_auth, s_auth } = res.data.data;
              console.log(1);
              if (p_auth) {
                console.log(2);
                if (!s_auth) {
                  console.log(3);
                  if (p_auth.status == 1) {
                    console.log(4);
                    //个人审核中
                    this.active = 1;
                    this.state = "个人认证审核中...";
                    this.textInfo = "个人类型认证成功后您将可以发布供需信息";
                    this.btnInfo = "申请个人认证";
                  } else if (p_auth.status == 2) {
                    this.active = 0;
                    this.state = "个人认证审核未通过，请重新提交";
                    this.textInfo = p_auth.ret_msg;
                    this.btnInfo = "重新申请个人认证";
                  } else if (p_auth.status == 3) {
                    console.log(5);
                    this.active = 2;
                    this.state =
                      "个人认证审核已通过，继续提交企业认证您将拥有自己的店铺";
                    this.textInfo = "您现在可以发布供需信息了";
                    this.btnInfo = "申请企业认证";
                  }
                } else {
                  if (s_auth.status == 1) {
                    //企业审核中
                    this.active = 4;
                    this.state = "企业认证审核中...";
                    this.textInfo = "提交企业认证，您将拥有自己的店铺";
                    this.btnInfo = "申请企业认证";
                  } else if (s_auth.status == 2) {
                    this.active = 2;
                    this.state = "企业认证审核未通过";
                    this.textInfo = s_auth.ret_msg;
                    this.btnInfo = "重新申请企业认证";
                  } else if (s_auth.status == 3) {
                    this.active = 5;
                    this.state = "完成入驻"+ this.storeType;
                    this.textInfo = "恭喜您入驻完成" ;
                    this.btnInfo = "查看认证信息";
                  } else {
                    this.active = 3;
                    this.state = "企业认证审核中...";
                    this.btnInfo = "申请企业认证";
                    this.textInfo = "提交企业认证，您将拥有自己的店铺";
                  }
                }
              } else {
                this.active = "";
                this.state = "个人认证尚未提交";
              }

              //    if(s_auth){
              //          if(s_auth==1){
              //            //企业审核中
              //            this.active =1
              //            this.state2 = '企业认证审核中'
              //            return
              //        }else if(s_auth==2){
              //             this.active =0
              //             this.state2 = '企业认证审核未通过'
              //              return
              //        }else if(s_auth==3){
              //             this.active =2
              //              this.state2 = '企业认证审核已通过'
              //        }
              //    }
            } else {
              this.$alert(res.data.resultMsg);
            }
          })
          .catch((err) => {
            this.$alert(JSON.stringify(err));
          });
      }
    },
    getFrontCardImg({ url }) {
      //   alert(1);

      this.authForm.front_img.value = url;
      this.$nextTick(() => {
        this.inputBlur();
      });
    },
    getBackCardImg({ url }) {
      console.log(url);

      this.authForm.reverse_img.value = url;
      this.$nextTick(() => {
        this.inputBlur();
      });
    },
    getHandCardImg({ url }) {
      this.authForm.hand_cardimg.value = url;
      this.$nextTick(() => {
        this.inputBlur();
      });
    },
    testForm(form, type) {
      console.log("form", form);
      let flag = true;
      for (var k in form) {
        let { value, reg, warning } = form[k];
        if (reg) {
          if (type) {
            if (warning) {
              let showTips = [];
              reg.forEach((item) => {
                console.log(1);
                if (!item.rule.test(value)) {
                  form[k].warning = item.info;
                  flag = false;
                  showTips.push(true);
                  console.log(k, value);
                } else {
                  showTips.push(false);
                }
              });
              console.log(showTips);
              showTips.every((item) => item == false) && (form[k].warning = "");
            }
            //   alert(1)
          } else {
            // alert(2)
            let showTips = [];
            reg.forEach((item) => {
              console.log(1);
              if (!item.rule.test(value)) {
                form[k].warning = item.info;
                flag = false;
                showTips.push(true);
                console.log(k, value);
              } else {
                showTips.push(false);
              }
            });
            console.log(showTips);
            showTips.every((item) => item == false) && (form[k].warning = "");
          }
        }
      }
      return flag;
    },
  },
  components: {
    PageSearchTitle,
  },
};
</script>

<style lang='less' scoped>
@media screen and(min-width:320px) and(max-width:1200px) {
  .authBox {
    margin: 5px 10px 0 !important;
  }
}

.authBox {
  margin: 5px 150px 0;
}
.steps {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.stepsBox {
}

.title {
  font-size: 16px;
  font-weight: 700;
  color: #454545;
  margin-top: 10px;
}
.authStatus {
  margin-left: 20px;
  font-size: 14px;
  color: #f01e1e;
  line-height: 40px;
}
.authStatusItem {
  margin-right: 20px;
  font-size: 14px;
}
.authContainer {
  // background-color: #f1f1f1;
  display: flex;
  flex-direction: row;
  margin-top: 10px;
}
.authBoxLeft {
  width: 200px;
  background-color: #f9f9f9;
  margin-right: 10px;
  padding: 10px;
  padding-left: 20px;
}
.authBoxRight {
  flex: 1;
  background-color: #f9f9f9;
}
.stepsTitle {
  font-size: 16px;
  font-weight: 700;
  color: #f70;
  margin-top: 10px;
  margin-bottom: 30px;
}
.startBox {
  text-align: center;
  margin-top: 100px;
}
.startBoxTitle {
  font-size: 14px;
  color: #454545;
  margin-bottom: 30px;
}
.startBoxBtn {
  width: 200px;
}
.startBoxTitleInfo {
  margin-bottom: 15px;
  color: #f70;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/Authen/Auth.vue